Ext.define('SA.view.InertMask', {
    constructor({getInteractiveEls}) {
        this.getInteractiveEls = getInteractiveEls;
    },

    apply() {
        this.getInertRoots().forEach(el => el.setAttribute('inert', ''));
    },

    clear() {
        document.querySelectorAll('[inert]').forEach(el => el.removeAttribute('inert'));
    },

    getInertRoots() {
        var result = [],
            interactiveEls = this.getInteractiveEls(),
            isInteractiveEl = el => interactiveEls.includes(el),
            containsInteractiveEl = el => interactiveEls.some(interactiveEl => el.contains(interactiveEl));

        addInertRootsRecursive(document.body);

        return result;

        function addInertRootsRecursive(el) {
            if (isInteractiveEl(el)) {
                return;
            }
            else if (containsInteractiveEl(el)) {
                Array.from(el.children).forEach(addInertRootsRecursive);
                return;
            }

            result.push(el);
        }
    }
});